import * as React from 'react';
import { useFela } from 'react-fela';
import { Link } from 'react-router-dom';

import { Box } from './generic/box/box';
import * as styles from './TopicMenu.style';

import type { PublicTag, Theme, Topic } from '../types';

interface Props {
  section: PublicTag;
  topics: Topic[];
  currentId: number;
  viewHash: string;
}

// The section's topics, with the current one marked. Only shown where there is
// somewhere to go: a section with a single topic gains nothing from a menu.
const TopicMenu = ({ section, topics, currentId, viewHash }: Props): React.ReactElement => {
  const { css, theme } = useFela<Theme>();

  return (
    <Box as="nav" style={styles.menu} className="kb-topic-menu">
      <Box as="h3" style={styles.heading(theme)} className="kb-topic-menu__heading">
        {section.name}
      </Box>
      {topics.map((topic) => (
        <Link
          key={`topic-menu-${topic.id}`}
          to={`/v/${viewHash}/c/${section.id}/t/${topic.id}`}
          className={`kb-topic-menu__row ${css(styles.row(theme, topic.id === currentId))}`}
          aria-current={topic.id === currentId ? 'page' : undefined}
        >
          <Box as="span" style={styles.label}>
            {topic.name}
          </Box>
          <Box as="span" style={styles.chevron}>
            <i className="fa fa-chevron-right" />
          </Box>
        </Link>
      ))}
    </Box>
  );
};

export default TopicMenu;
